<template>
  <b-input-group>
    <b-form-input 
      :value="text" 
      readonly 
    />
        
    <b-button 
      :variant="copied ? 'outline-success' : 'outline-secondary'" 
      @click="copyToClipboard(text)"
    >
      <i class="fa fa-copy" /> {{ copied ? 'Gekopieerd!' : '' }}
    </b-button>
  </b-input-group>
</template>
<script>
export default {
    name: 'CopyText',
    components: {},
    mixins: [],
    props: {
        text: {
            type: String,
            required: true
        }
    },
    data() {
        return  {
            copied : false
        }
    },
    computed: {},
    watch: {},
    mounted () {
        
    },
    methods: {
        copyToClipboard(text) {
            return navigator.clipboard.writeText(text).then(() => this.copied = true).finally(() => setTimeout(() => this.$set(this,'copied', false), 2000).bind(this));
        }
    },
          
}
</script>